module.exports = __webpack_public_path__ + "static/BenRogers_lab-175274f18110c6aff77488a3e01b7dfc.png";